import { useEffect, useState } from "react";
// import HomeHeader from "../../components/Home/HomeHeader/HomeHeader";
// import HomeNavbar from "../../components/Home/HomeNavbar/HomeNavbar";

import useHomePage from "../../hooks/useHomePage";
import HomeSkeleton from "../../components/Home/HomeSkeleton/HomeSkeleton";
import HomeError from "../../components/Home/HomeError/HomeError";

import HeroSlider from "../../components/Home/HeroSlider/HeroSlider";
import SpecialOffers from "../../components/Home/SpecialOffers/SpecialOffers";
import PromotionalBanners from "../../components/Home/PromotionalBanners/PromotionalBanners";
import Categories from "../../components/Home/Categories";
import Brands from "../../components/Home/Brands";
//import Footer from "../../components/Footer/Footer";
// import Footer from "../../components/Footer/Footer_static";

import ArticlesSection from "../../components/Home/Articles/ArticlesSection";

import HomeContainer from "../../components/HomeContainer/HomeContainer";
import FullHomeContainer from "../../components/FullHomeContainer/FullHomeContainer";

import ProductTabs from "../../components/ProductTabs";
import "../../styles/ProductTabs.css";
import HomepageSectionByType from "../../components/Home/HomepageSections/HomepageSectionByType";
export default function HomePage() {
  const { data, isLoading, error, refetch } = useHomePage();
  const sections = data?.sections ?? [];


  if (isLoading) {
    return <HomeSkeleton />;
  }

  if (error) {
    return <HomeError onRetry={refetch} />;
  }

  return (
    <>
      <HeroSlider slides={data.home.slider} />



      {/* <ProductTabs /> */}



      <HomeContainer>
         <Categories categories={data.home.categories} />
         
        <HomepageSectionByType sections={sections} type="ammazing" />

        <PromotionalBanners banners={data.home.advertises[0]?.items} />

        <HomepageSectionByType sections={sections} type="newest" />

        <Brands brands={data.home.brands} />

        <PromotionalBanners banners={data.home.advertises[1]?.items} />

        {/* <ProductTabs /> */}

       


        <HomepageSectionByType sections={sections} type="most_visited" />


        <HomepageSectionByType sections={sections} type="most_popular" />

        <ArticlesSection articles={data.home.articles} />

        {/* <Footer /> */}
      </HomeContainer>
    </>
  );
}
